import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, DatePipe } from '@angular/common';
import { StoreService } from './services/store.service';
import { PipeModule } from './pipes/pipe.module';
import { ToasterService } from './services/toaster.service';
import { CanvasComponent } from './components/canvas/canvas.component';
import { UtilService } from './services/util.service';
import { ProcessService } from './services/process.service';
import { RemediesService } from './services/remedies.service';
@NgModule({
  declarations: [CanvasComponent],
  imports: [FormsModule, ReactiveFormsModule, CommonModule, PipeModule],
  exports: [FormsModule, ReactiveFormsModule, CommonModule, CanvasComponent, PipeModule],
  providers: [ProcessService, RemediesService, StoreService, ToasterService, UtilService, DatePipe]
})
export class SharedModule {}
